import { useSuspenseQuery } from '@tanstack/react-query';
import { getProviderDocuments } from '@uplift/api';
import { BaseSuspenseQueryOpts } from '../baseTypes';


export const useProviderDocumentsQuery = (providerId: string, opts?: BaseSuspenseQueryOpts) => {
  return useSuspenseQuery({
    queryKey: [ 'user', providerId, 'documents' ],
    queryFn: async () => {
      const response = await getProviderDocuments(providerId);

      return response.data;
    },
    ...opts,
  });
};
